/**
 * 教师班级关系 API
 * 用于查询班级与班主任等关系
 * relation_type: 0=任课教师, 1=班主任
 */
import { request } from './request'

/**
 * 获取所有教师班级关系
 * @returns {Promise<{ success, data, count }>}
 * data: [{ relation_id, teacher_id, class_id, relation_type, ... }]
 */
export function getTeacherClassRelations() {
  return request('/api/teacher-class-relations/')
}

/**
 * 根据ID获取教师班级关系
 * @param {number|string} id - 关系ID
 */
export function getTeacherClassRelation(id) {
  return request(`/api/teacher-class-relations/${id}`)
}

/**
 * 根据用户ID获取该教师的班级关系
 * @param {number|string} userId - 用户 ID (user_id)
 * @returns {Promise<{ success, data, count }>}
 * data: [{ relation_id, teacher_id, class_id, relation_type, ... }]
 */
export function getTeacherClassRelationsByTeacher(userId) {
  return request(`/api/teacher-class-relations/teacher/${userId}`)
}

/**
 * 创建教师班级关系
 * @param {object} data - { teacher_id, class_id, relation_type, create_by }
 */
export function createTeacherClassRelation(data) {
  return request('/api/teacher-class-relations/', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 更新教师班级关系
 * @param {number|string} id - 关系ID
 * @param {object} data - { relation_type?, update_by }
 */
export function updateTeacherClassRelation(id, data) {
  return request(`/api/teacher-class-relations/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

/**
 * 删除教师班级关系
 * @param {number|string} id - 关系ID
 */
export function deleteTeacherClassRelation(id) {
  return request(`/api/teacher-class-relations/${id}`, {
    method: 'DELETE'
  })
}
